import {Button, Popover, Switch, withStyles} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export const CustomPopover = withStyles({
  paper: {
    // Allow overflow to show shadow
    overflowY: 'initial',
    overflowX: 'initial',
  },
})(Popover);

export const CustomTooltip = withStyles({
  tooltip: {
    padding: '8px 16px',
    borderRadius: 8,
    background: '#1D1D1B',
    color: '#FFFFFF',
    fontSize: '14px',
    lineHeight: '16px',
  },
})(Tooltip);

export const CustomFormControlLabel = withStyles({
  root: {
    marginRight: 0,
  },
  label: {
    paddingLeft: 16,
    fontFamily: 'Kaspersky Sans Display',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#1D1D1B',
  },
})(FormControlLabel);

export const CustomSwitch = withStyles({
  root: {
    width: 44,
    height: 24,
    padding: 0,
  },
  track: {
    borderRadius: 16,
    backgroundColor: 'rgba(29, 54, 83, 0.17)',
    opacity: 1,
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: '0px 4px 4px -2px rgba(24, 39, 75, 0.08), 0px 2px 4px -2px rgba(24, 39, 75, 0.12)',
    backgroundColor: '#FFFFFF',
  },
  switchBase: {
    padding: 4,
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: 'white',
      '& + $track': {
        backgroundColor: '#00A88E',
        opacity: 1,
        border: 'none',
      },
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
})(Switch);

export const CustomButton = withStyles({
  root: {
    borderRadius: 8,
    fontFamily: 'Kaspersky Sans Display, sans-serif',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
    paddingBlock: '10px',
  },
  outlined: {
    border: '2px solid #00A88E',
    color: '#00A88E',
    background: '#FFFFFF',
  },
  contained: {
    border: 'none',
    color: '#FFFFFF',
    background: '#00A88E',
    '&:hover': {
      background: '#00A88E',
    },
  },
})(Button);
